


(function ($)
{
    'use strict';


    $(window).load(function ()
    {
        /*
         * Blog items clickable
         */
        $(".pointer").click(function()
        {
            window.location = $(this).find("a").attr("href");
            return false;
        });


        /*
         * Eerste twee home items even groot
         */

        function resizeBlogItems ()
        {
            var $items = $('.blog-item .pointer');

            if ( $('body').width() >= 500 )
            {
                var maxHeight = 0;

                $items.each( function ()
                {
                    var height = $(this).height();

                    if ( height > maxHeight )
                    {
                        maxHeight = height;
                    }
                });

                $items.height(maxHeight);
            }
            else
            {
                $items.height('auto');
            }
        }

        function resizeBlogImages ()
        {
            var $items = $('.blog-item .pointer');

            if ( $('body').width() >= 500 )
            {
                var maxImgHeight = 0;

                $items.each( function ()
                {
                    if ( $(this).parent('.blog-item').is(':first-child') )
                    {
                        var imgHeight = $(this).find('.imgholder').height();

                        if ( imgHeight > maxImgHeight )
                        {
                            maxImgHeight = imgHeight;
                        }
                    }
                });

                $items.find('.imgholder').height(maxImgHeight);
            }
            else
            {
                $items.find('.imgholder').height('auto');
            }
        }

        resizeBlogImages();
        resizeBlogItems();
        $(window).on('resize', resizeBlogItems);







        var zoekbalk = $('.searchfield');
        if(zoekbalk.length > 0){



            zoekbalk.click(function () {

                if(zoekbalk.hasClass('closed')){

                    $(this).addClass('open').removeClass('closed');
                    return false;
                }

            });



            $(document).click(function (e) {
               if(!$(e.target).hasClass('input-sm')){



                   zoekbalk.addClass('closed').removeClass('open');
                 }
            });


        }



    });

}) (jQuery);



